import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import BlogDetail from "./pages/BlogDetail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import FAQPage from "./pages/FAQPage";
import CostCalculator from "./pages/CostCalculator";
import TokenCalculator from "./pages/TokenCalculator";
import ProviderSelector from "./pages/ProviderSelector";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CreateAlert from "./pages/CreateAlert";
import EditAlert from "./pages/EditAlert";
import ScrollToTop from "./components/ScrollToTop";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/cost-calculator" element={<CostCalculator />} />
          <Route path="/token-calculator" element={<TokenCalculator />} />
          <Route path="/provider-selector" element={<ProviderSelector />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts/create"
            element={
              <ProtectedRoute>
                <CreateAlert />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts/edit/:id"
            element={
              <ProtectedRoute>
                <EditAlert />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Analytics />
        <SpeedInsights />
      </Router>
    </AuthProvider>
  );
};

export default App;
